import {
  isInteger,
} from 'lodash';
import WebFont from 'webfontloader';

import {
  getPartnerFonts,
  getPartnerFontsWebfontsConfig,
} from '@/helpers/common';

export const DEFAULT_WL_CONFIG = {
  marketingOptions: null,
  brandingType: 'Quotezone',
};

export const processConfig = (rawConfig, productName) => {
  const config = {};

  Object.keys(rawConfig).forEach(key => {
    if (
      isInteger(rawConfig[key]) ||
      ['0', '1'].includes(rawConfig[key])
    ) {
      config[key] = !!rawConfig[key];
    } else if (rawConfig[key] === '') {
      // need to keep partnerFooterText as '' to keep it working with partners that have unique footers (for now only TotallyMoney)
      // if it's '' and there is no unique footer for a partner, nothing will be rendered
      config[key] = key !== 'partnerFooterText' ? null : '';
    } else if (
      [
        'partnerTheme',
        'partnerFont1',
        'partnerFont2',
        'partnerFont3',
        'partnerAdvancedTheme',
      ].includes(key)
    ) {
      config[key] = JSON.parse(rawConfig[key]);
    } else {
      config[key] = rawConfig[key];
    }
  });

  // TODO - to remove when added to config on BE side
  if (!Object.prototype.hasOwnProperty.call(config, 'isVerticalSplitted')) {
    config.isVerticalSplitted = ['home', 'travel', 'breakdown'].includes(productName);
  }

  return config;
};

export const initPartnerFonts = config => {
  const partnerFonts = getPartnerFonts(config);
  const partnerFontsConfig = getPartnerFontsWebfontsConfig(partnerFonts);

  const vars = {};

  partnerFonts.forEach((font, index) => {
    if (!font) return;
    document.querySelector(':root').style.setProperty(`--font-${index + 1}`, font.name);
    vars[`--font-${index + 1}`] = font.name;
    font.weight && document.querySelector(':root').style.setProperty(`--font-${index + 1}-weight`, font.weight);
    vars[`--font-${index + 1}-weight`] = font.weight;
  });

  partnerFontsConfig && WebFont.load(partnerFontsConfig);
};

export const setupMetaTags = config => {
  const { primary: primaryColor } = config.partnerTheme;
  let faviconUrl;

  if (process.env.NODE_ENV === 'production') {
    if (config.partnerNameFavicon.indexOf('http') === 0) {
      faviconUrl = config.partnerNameFavicon;
    } else {
      faviconUrl = `/${process.env.VUE_APP_FOLDER_NAME || 'quotezone-ui'}/${config.partnerNameFavicon}`;
    }
  } else {
    faviconUrl += `/${process.env.VUE_APP_FOLDER_NAME || 'quotezone-ui'}/favicon_${process.env.VUE_APP_PARTNER}.ico`;
  }

  const meta = [
    {
      name: 'theme-color',
      content: primaryColor,
    },
    {
      name: 'msapplication-TileColor',
      content: primaryColor,
    },
  ];

  const names = [
    'newQuotezoneResponsive',
    'newCniwlResponsive',
    'quotezonenew',
    'quotezone',
    'cniwl',
    'compareni',
  ];

  const isQzOrCompareNi = names.includes(config.partner);
  const isNoFollow = config.robotNoFollow;

  if (!isQzOrCompareNi) {
    meta.push({
      name: 'robots',
      content: isNoFollow ? 'noindex,nofollow' : 'noindex',
    });
  }

  const link = [
    {
      rel: 'icon',
      href: faviconUrl,
    },
  ];

  if (config.canonical) {
    link.push({
      rel: 'canonical',
      href: config.canonical,
    });
  }

  return {
    meta,
    link,
  };
};
